import { render } from "./scoringConfiguration.vue?vue&type=template&id=08d43827&ts=true"
import script from "./scoringConfiguration.vue?vue&type=script&lang=ts"
export * from "./scoringConfiguration.vue?vue&type=script&lang=ts"

import exportComponent from "/app/node_modules/vue-loader-v16/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__